import * as constants from "./constants";
import { format } from "date-fns";
import { actionCreators as actionCreatorsModal } from "../../modal";
import API from "../../../server";
import {
  SUBSCRIPTION_PAYMENT_REQUIREMENT,
  LINKS,
  OWNER_ROLE,
  PLAN_OPTIONS,
} from "utils/constants";

const setDueProjects = (result) => ({
  type: constants.SET_DUE_PROJECT,
  result,
});
export const setData = (name, value) => ({
  type: constants.SET_DATA,
  name,
  value,
});
export const setImuData = (name, value) => ({
  type: constants.SET_IMU_DATA,
  name,
  value,
});

export const getNoticeInfo = () => {
  return (dispatch) => {
    dispatch(getDueProjects());
    dispatch(getNoticeNum());
    dispatch(getSetupProcess(false));
    dispatch(getDueContracts());
  };
};

const getDueContracts = () => {
  return (dispatch) => {
    API.read_all_claims_received()
      .then((res) => res.data)
      .then((res) => res.data.certlist)
      .then((res) => {
        if (!res) return;
        let hasDueContract = res.filter(
          (item) =>
            (item.cert_due_num !== 0 && item.cert_due_num < 8) ||
            item.unclaimed_days >= 30,
        );
        dispatch(setImuData("due_contracts", hasDueContract.length));
      });
  };
};

const getDueProjects = () => {
  let date = format(new Date(), "yyyy-MM-dd");
  return (dispatch) => {
    API.read_claim_summary({
      claim_date: date,
      is_all: true,
    })
      .then((res) => res.data)
      .then((res) => res.data.claimsummary)
      .then((res) => dispatch(setDueProjects(res)));
  };
};

export const getSetupProcess = (triggerClose) => {
  return (dispatch) => {
    API.read_setup_process()
      .then((res) => res.data)
      .then((res) => res.data.result)
      .then((res) =>
        dispatch({
          type: constants.SET_UP_PROCESS,
          payload: res,
          triggerClose,
        }),
      );
  };
};

export const getAccountIntegrationLogs = () => {
  return (dispatch) => {
    API.read_account_integration_logs()
      .then((res) => res.data)
      .then((res) =>
        dispatch({
          type: constants.SET_INTEGRATION_LOGS,
          payload: res.data,
        }),
      );
  };
};

export const getAccountStatistics = () => {
  return (dispatch) => {
    API.read_account_statistics()
      .then((res) => res.data)
      .then((res) => res.data.data)
      .then((res) => {
        dispatch(setData("accountStatistics", res));
      });
  };
};

export const getNoticeNum = () => {
  return (dispatch) => {
    API.read_notice_num()
      .then((res) => res.data)
      .then((res) => res.data.notenums)
      .then((res) => dispatch(setData("noticeNum", res)));
  };
};

export const login = (data) => {
  return async (dispatch) => {
    if (data) {
      dispatch(loginSuccess(data));
    } else {
      API.login_info()
        .then((res) => res.data)
        .then((res) => {
          dispatch(loginSuccess(res.data.profile));
        });
    }
  };
};

export const loginSuccess = (result) => {
  return {
    type: constants.LOGIN_SUCCESS,
    profile: result,
  };
};

export const loginFailed = () => ({
  type: constants.LOGIN_FAILED,
});

// * notification
//delete notice
export const deleteNotice = (noticeId) => {
  return (dispatch) => {
    dispatch(
      actionCreatorsModal.showModal("delete", {
        open: true,
        title: "Notification",
        message: "notification",
        api: {
          name: "delete_one_notice",
          config: [noticeId],
        },
        action: [readAllNotice(), getNoticeNum()],
      }),
    );
  };
};

export const readAllNotice = () => {
  return (dispatch) => {
    API.read_all_notice()
      .then((res) => res.data)
      .then((res) => res.data.notifications)
      .then((res) => dispatch(setAllNotice(res)));
  };
};

export const setAllNotice = (data) => ({
  type: constants.SET_NOTICE_DATA,
  payload: data,
});

export const setHelpDeskMode = (name, value) => {
  return (dispatch) => {
    API.update_account_detail({ is_help_mode: value })
      .then((res) => res.data)
      .then((res) => {
        dispatch(setData(name, value));
      });
  };
};

export const getSubscription = () => {
  return (dispatch) => {
    // Check if the subscription notice has already been closed in this session
    const isNoticeClosed = localStorage.getItem("subscriptionNoticeClosed");
    if (isNoticeClosed) {
      return;
    }

    API.read_subscription()
      .then((res) => res.data)
      .then((res) => {
        const subscriptionResponse = res?.data?.data;
        if (
          [
            SUBSCRIPTION_PAYMENT_REQUIREMENT.NO_SUBSCRIPTION.code,
            SUBSCRIPTION_PAYMENT_REQUIREMENT.UPGRADE_SUBSCRIPTION.code,
            SUBSCRIPTION_PAYMENT_REQUIREMENT.EXCEED_SUBSCRIPTION.code,
          ].includes(subscriptionResponse?.status)
        ) {
          // Show Banner with subscription details
          const subscriptionDetails = res?.data;
          dispatch(setSubscriptionNotice(subscriptionDetails));
        }
        return res?.data;
      });
  };
};

export const setSubscriptionNotice = (data) => ({
  type: constants.SET_SUBSCRIPTION_NOTICE,
  data,
});

export const closeSubscriptionNotice = () => {
  return (dispatch) => {
    // Set flag in localStorage to indicate that the user closed the subscription notice
    localStorage.setItem("subscriptionNoticeClosed", true);
    dispatch(setData("showSubscriptionNotice", false));
  };
};

export const showSubscriptionModal = (subscriptionResponse) => {
  return (dispatch, getState) => {
    const subscriptionDetails =
      subscriptionResponse ||
      getState().getIn(["headers", "subscriptionDetails"]).toJS();
    if (!subscriptionDetails) return; // Early exit if subscriptionDetails are not found

    const paymentCode =
      subscriptionDetails?.status || subscriptionDetails?.data?.status || -1;
    let planPayment = PLAN_OPTIONS.PLANPRICE;
    let planButtonText = "View Plans";
    let selectedModalInfoType = "";

    const { NO_SUBSCRIPTION, UPGRADE_SUBSCRIPTION, EXCEED_SUBSCRIPTION } =
      SUBSCRIPTION_PAYMENT_REQUIREMENT;
    switch (paymentCode) {
      case NO_SUBSCRIPTION.code:
        selectedModalInfoType = NO_SUBSCRIPTION.keyForModal;
        break;

      case UPGRADE_SUBSCRIPTION.code:
        selectedModalInfoType = UPGRADE_SUBSCRIPTION.keyForModal;
        planPayment = PLAN_OPTIONS.PLANPAYMENT;
        break;

      case EXCEED_SUBSCRIPTION.code:
        selectedModalInfoType = EXCEED_SUBSCRIPTION.keyForModal;
        planPayment = PLAN_OPTIONS.PLANPAYMENT;
        planButtonText = "Get in Touch";
        break;

      default:
        return;
    }

    if (!selectedModalInfoType) return;
    const profile = getState()?.getIn(["headers", "profile"]).toJS();
    const accountRole = getState()?.getIn(["headers", "accountRole"]);
    let buttonPlaceholderText = "";
    if (accountRole !== OWNER_ROLE) {
      const accountOwnerName =
        getState()?.getIn([
          "manageAccount",
          "accountInfo",
          "account_owner_name",
        ]) || "";

      buttonPlaceholderText = `Please contact the account owner ${accountOwnerName} to get started`;
    }

    const handleClick =
      accountRole === OWNER_ROLE
        ? () => {
            const link = `/manage-account/${planPayment}`;
            const redirectProps = {
              search: `?account_id=${profile?.payclaim_account_id}`,
            };

            if (paymentCode === EXCEED_SUBSCRIPTION.code) {
              return [LINKS.CONTACT, "external"];
            }

            if (paymentCode === NO_SUBSCRIPTION.code) {
              redirectProps.state = {
                noPermission: false,
              };
            }

            return [link, redirectProps];
          }
        : undefined;

    dispatch(
      actionCreatorsModal.showModal("subscriptionNotice", {
        isOpen: true,
        infoType: selectedModalInfoType,
        errorMessage:
          subscriptionDetails?.data?.errors?.[0] || "An error occurred.",
        buttonPlaceholderText,
        planButtonText,
        handleClick,
        getAccountStatistics: () => dispatch(getAccountStatistics()),
      }),
    );
  };
};

export const setIntegrationError = (data) => ({
  type: constants.SET_INTEGRATION_ERROR,
  data,
});

export const showIntegrationErrorBanner = (errorResponse) => {
  return (dispatch, getState) => {
    const errorDetails =
      errorResponse ||
      getState().getIn(["headers", "integrationErrorDetails"]).toJS();

    if (!errorDetails) return;

    dispatch(setIntegrationError(errorDetails));
    sessionStorage.setItem("integrationErrorClosed", false);
    dispatch(setData("showIntegrationError", true));
  };
};

export const closeIntegrationErrorBanner = () => {
  return (dispatch) => {
    sessionStorage.setItem("integrationErrorClosed", true);
    dispatch(showIntegrationErrorBanner([]));
    dispatch(setData("showIntegrationError", false));
  };
};

export const toggleDemoMode = (enableDemoMode) => {
  return (dispatch) => {
    API.toggle_demo_mode(enableDemoMode).then(() => {
      dispatch(setData("isDemoMode", enableDemoMode));

      // Redirect users to dashboard if they successfully enable demo mode
      if (enableDemoMode) {
        const accId = localStorage.getItem("paylab_account_id") || "";
        window.location.href = `/dashboard?account_id=${accId}`;
      } else {
        window.location.reload();
      }
    });
  };
};
